var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2545 16.1426L15.1642 17.9861C15.5362 18.2218 15.9979 17.8713 15.8876 17.4371L15.0469 14.1301C15.0232 14.038 15.026 13.941 15.055 13.8504C15.0839 13.7599 15.1379 13.6793 15.2106 13.618L17.8199 11.4463C18.1627 11.1609 17.9858 10.5919 17.5453 10.5633L14.1377 10.3422C14.046 10.3356 13.9579 10.3031 13.8839 10.2485C13.8099 10.1938 13.7529 10.1193 13.7196 10.0335L12.4487 6.83312C12.4142 6.74207 12.3528 6.66369 12.2726 6.60837C12.1925 6.55306 12.0974 6.52344 12 6.52344C11.9026 6.52344 11.8075 6.55306 11.7274 6.60837C11.6473 6.66369 11.5858 6.74207 11.5513 6.83312L10.2804 10.0335C10.2471 10.1193 10.1901 10.1938 10.1161 10.2485C10.0421 10.3031 9.95405 10.3356 9.86227 10.3422L6.45473 10.5633C6.01425 10.5919 5.83729 11.1609 6.18014 11.4463L8.7894 13.618C8.86212 13.6793 8.91606 13.7599 8.94502 13.8504C8.97398 13.941 8.97678 14.038 8.95311 14.1301L8.17347 17.197C8.04103 17.718 8.59517 18.1386 9.0415 17.8558L11.7455 16.1426C11.8216 16.0942 11.9098 16.0685 12 16.0685C12.0902 16.0685 12.1784 16.0942 12.2545 16.1426V16.1426Z",
    stroke: "currentColor",
    strokeWidth: 1.64103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.42c3ca37.svg";
export { ForwardRef as ReactComponent };